import { render, staticRenderFns } from "./ShopCardShopping.vue?vue&type=template&id=0371de50&scoped=true"
import script from "./ShopCardShopping.vue?vue&type=script&lang=js"
export * from "./ShopCardShopping.vue?vue&type=script&lang=js"
import style0 from "./ShopCardShopping.vue?vue&type=style&index=0&id=0371de50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0371de50",
  null
  
)

export default component.exports